var path = 'batch/details/details.tpl.html';
var html = "<react-component name='batch-details' />\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;